/* eslint-disable react-hooks/rules-of-hooks */
import { Operator } from '@jexop/core';
import { isString } from 'lodash';
import { useAuthenticated } from '../auth';

export const ifRoleFunction: Operator<boolean> = ({ role }): boolean => {
  const { userInfo } = useAuthenticated();

  if (!isString(role)) {
    return false;
  }

  if (userInfo.hasRoleFunction(role)) {
    return true;
  }

  return false;
};
